(() => {
  angular
    .module('app.campaign')
    .controller('AdhCollisionModalController', AdhCollisionModal);

  AdhCollisionModal.$inject = [
    '$element',
    'close',
    'collision',
    'addNewTrackpoints',
  ];

  function AdhCollisionModal(
    $element,
    close,
    collision,
    addNewTrackpoints,
  ) {
    const vm = this;

    vm.campaign = collision.campaign;
    vm.io = collision.io;
    vm.level = vm.io || vm.campaign;

    vm.addTrackpoints = () => {
      addNewTrackpoints();
      vm.close();
    }

    const removeBackdrop = () => $('.modal-backdrop').remove();

    vm.close = () => {
      removeBackdrop();

      $element.modal('hide');
      close(null, 500);
    };
  }
})();
